import { render, staticRenderFns } from "./ReportRoads.vue?vue&type=template&id=2c55787f&scoped=true&"
import script from "./ReportRoads.vue?vue&type=script&lang=js&"
export * from "./ReportRoads.vue?vue&type=script&lang=js&"
import style0 from "./ReportRoads.vue?vue&type=style&index=0&id=2c55787f&scoped=true&lang=css&"
import style1 from "./ReportRoads.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c55787f",
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon,QBtn,QTooltip,QBanner,QItem,QInput,QSelect,QChip,QItemSection,QItemLabel,QSpace,QToolbar,QToolbarTitle,QTabs,QTab,QDialog,QAvatar,QSeparator,QCardActions,QInnerLoading,QSpinnerGears,QField} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QIcon,QBtn,QTooltip,QBanner,QItem,QInput,QSelect,QChip,QItemSection,QItemLabel,QSpace,QToolbar,QToolbarTitle,QTabs,QTab,QDialog,QAvatar,QSeparator,QCardActions,QInnerLoading,QSpinnerGears,QField}, component.options.components || {})
